import { Destroyable, untilDestroy, taxV3ModalityLabels, selectAllExpenseCategories } from '@tokeet/tv3-platform'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { TaxModalities } from '@tokeet/cost-resolver'
import { Observable, of } from 'rxjs'
import { map, startWith, withLatestFrom } from 'rxjs/operators'
import { select } from '@ngrx/store'
import * as R from 'ramda'

@Component({
  selector: 'app-tax-form',
  templateUrl: './tax-form.component.html',
  styleUrls: ['./tax-form.component.scss'],
})
export class TaxFormComponent extends Destroyable implements OnInit {
  @Input() taxes: FormGroup[]
  @Input() index: number

  @Output() remove = new EventEmitter<number>()

  form: FormGroup

  constructor() {
    super()
  }

  taxName$: Observable<string>
  taxes$ = of([
    {
      type: 'TAXES & FEES',
      id: 'htg.city_tax',
      name: $localize`City tax`,
      description: $localize`Tax imposed by a governement`,
    },
    {
      id: 'htg.eco_tax',
      type: 'TAXES & FEES',
      description: $localize`Tax for environmental costs. Usually out of provider's control and sent to us as something about environment/ecology`,
      name: $localize`Eco tax`,
    },
    {
      id: 'htg.local_tax',
      type: 'TAXES & FEES',
      description: $localize`Tax imposed by a governement`,
      name: $localize`Local tax`,
    },
    {
      name: $localize`Short stay tax`,
      description: $localize`Tax imposed by a governement`,
      type: 'TAXES & FEES',
      id: 'htg.short_stay_tax',
    },
    {
      id: 'htg.tourist_tax',
      type: 'TAXES & FEES',
      description: $localize`Tax imposed by a governement`,
      name: $localize`Tourist tax`,
    },
    {
      id: 'htg.vat',
      type: 'TAXES & FEES',
      description: $localize`VAT/MwSt/Sales tax. Any additional tax when buying/selling something`,
      name: 'Vat',
    },
  ])
  filteredTaxes$
  taxV3Modalities = TaxModalities
  taxV3ModalityLabels = taxV3ModalityLabels

  ngOnInit() {
    this.form = this.taxes['controls'][this.index]

    this.taxName$ = this.form.get('name').valueChanges.pipe(startWith(''))
    this.filteredTaxes$ = this.taxName$.pipe(
      withLatestFrom(this.taxes$),
      map(([taxName, taxes]) => this.filterTaxes(taxName, taxes))
    )
  }

  filterTaxes(taxName: string, taxes: any[]) {
    const filterValue = taxName?.toLowerCase() || ''

    if (R.isEmpty(taxName)) {
      return taxes
    }

    return taxes.filter((t) => t.name.toLowerCase().indexOf(filterValue) === 0)
  }
}
